import React from "react";
import { useParams } from "react-router-dom";
import AINewSettingsTabs from "./AINewSettingsTabs";
import ChannelOverrideEditor from "../ChannelOverrideEditor";

export default function AINewSettingsChannelOverrides() {
  const { id } = useParams<{ id: string }>();
  const aiConfigId = id ? parseInt(id, 10) : 0;

  return (
    <>
      <AINewSettingsTabs aiConfigId={id ?? ""} />
      <div className="max-w-4xl mx-auto px-4 pb-12">
        {aiConfigId > 0 && <ChannelOverrideEditor aiConfigId={aiConfigId} />}
      </div>
    </>
  );
}
